import axios from "axios";
import { getCFCountry, getCFIP, getPaymentCountry } from "./setCookie";
import { annotateRateLimitResponse } from "./rateLimit";

const url = process.env.FULL_DOMAIN;

const axiosInternal = (options) => {
  // Clone so we never mutate the caller's headers object (SSR cross-request leak guard).
  const additionalHeaders = { ...(options.headers || {}) };
  const payment_country = getPaymentCountry(options.ctx);
  const cfConfig = {
    config_country: getCFCountry(options.ctx),
    config_IP: getCFIP(options.ctx)
  };
  if (cfConfig.config_country) {
    additionalHeaders["X-HTTP-IPCOUNTRY"] = cfConfig.config_country;
  }
  if (cfConfig.config_IP) {
    additionalHeaders["X-HTTP-CONNECTING-IP"] = cfConfig.config_IP;
  }

  if (payment_country) {
    additionalHeaders["X-Client-Country-Code"] = payment_country;
  }

  const client = axios.create({
    baseURL: url,
    headers: {
      ...additionalHeaders,
    }
  });

  // eslint-disable-next-line arrow-body-style
  const onSuccess = (response) => {
    // console.debug('Request Successful!', response);
    return response.data;
  };

  const onError = (error) => {
    // Log the failing call, not just the base domain — "Request Failed:
    // https://myfitsociety.com/" told us nothing about WHICH fetch died.
    const failed = (error && error.config) || {};
    const status = error && error.response && error.response.status;
    console.error(
      "Request Failed:",
      String(failed.method || options.method || "GET").toUpperCase(),
      String(failed.baseURL || url || "") + String(failed.url || options.url || ""),
      status ? `status=${status}` : (error && error.message) || "unknown"
    );
    // Network failures rejected with a bare string before; callers read
    // e.status/e.data/e.message on it, which is how a dead fetch turned into
    // "Cannot read properties of undefined" crashes. Reject the axios error
    // so e.message/.config always exist; the response-object path is unchanged.
    // 429: add retryAfter (+ a friendly message when the language is known).
    return Promise.reject(annotateRateLimitResponse(error.response, options.ctx) || error);
  };

  return client(options)
    .then(onSuccess)
    .catch(onError);
};

export default axiosInternal;
